var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FontAwesomeIcon',{class:{
		'title-poster-ribbon--active': _vm.isInWatchlist,
		'title-poster-ribbon': true,
	},attrs:{"icon":"bookmark"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.toggleInWatchList(_vm.isInWatchlist)}}})}
var staticRenderFns = []

export { render, staticRenderFns }